module.exports = __webpack_public_path__ + "static/MonumentExtended-Ultrabold-dc16ce59392f4821b136670d351868cb.woff";